import { useMessages, useTranslations } from 'next-intl'
import Image from 'next/image'
import RoundedCheckMark from '../../../../components/icons/RoundedCheckMark'
import GoldLinkButton from '../../../../components/GoldLinkButton'
import TextWithLineBreaks from 'src/app/components/TextWithlineBreak'

const RolzoServices = ({ locale }) => {
  const t = useTranslations('home-page.rolzoServicesSection')
  const messages = useMessages()
  const isSpanish = locale === 'es'
  const isPortuguese = locale === 'pt-BR'

  const keys =
    Object.keys(messages['home-page'].rolzoServicesSection.cards) || []

  return (
    <>
      <section className='pt-12 pb-8  container px-[15px] text-[#212529] flex flex-col font-light gap-8 items-center '>
        <TextWithLineBreaks
          t={t}
          elementClassName={`leading-[1.4] px-[15px] sm:px-0 ${isPortuguese ? 'max-w-[552px]' : 'max-w-[540px]'}  mx-auto md:text-center`}
          textKey='title'
          lineBreakClassname='hidden md:block'
          element='h3'
        />
        <TextWithLineBreaks
          t={t}
          elementClassName='max-w-[540px] md:text-center text-[18px] md:text-[16px] leading-[1.6] mx-auto px-[15px]'
          textKey='text'
          lineBreakClassname='hidden md:block'
          element='p'
        />
        {keys.map((key) => {
          const card = messages['home-page'].rolzoServicesSection.cards[key]
          return (
            <div
              key={key}
              className='grid grid-cols-1 text-[#212529] md:grid-cols-2 md:gap-[35px] w-full  items-center border border-rolzo-grey/[43%] rounded-[10px] pt-4 pb-6 md:py-4 text-left'
            >
              <div className='mb-4 md:mb-0'>
                <Image
                  width={424}
                  height={300}
                  quality={75}
                  src={t(`cards.${key}.image`)}
                  alt={`Image illustrating ${key}`}
                  className='object-contain rounded-lg'
                  decoding='async'
                  sizes='(min-width: 1200px) 960px,
  (min-width: 767px) 326px,
  100vw'
                />
              </div>
              <div className='flex flex-col gap-4 px-[15px] md:px-0'>
                <h2 className='font-normal text-[18px] md:text-[16px]'>
                  {t(`cards.${key}.title`)}
                </h2>

                <TextWithLineBreaks
                  t={t}
                  elementClassName={`${isSpanish ? '' : 'max-w-[85%]'} text-[18px] line-clamp-3 md:text-[16px] leading-[1.6]`}
                  textKey={`cards.${key}.description`}
                  lineBreakClassname='hidden xl:block'
                  element='p'
                />

                <ul className='space-y-[6px]'>
                  {Object.entries(card.features).map(
                    ([featureKey, featureValue], index) => (
                      <li key={index} className='flex items-center gap-3'>
                        <RoundedCheckMark /> {featureValue}
                      </li>
                    )
                  )}
                </ul>
                {t(`cards.${key}.link`, { fallback: null }) && (
                  <GoldLinkButton
                    href={t(`cards.${key}.link`)}
                    text='Learn more'
                    className='!p-0 mt-2'
                  />
                )}
              </div>
            </div>
          )
        })}
      </section>
      <div className='pb-12 pt-12 xl:pt-0 xl:pb-40  flex leading-[1.5] justify-center'>
        <GoldLinkButton
          isCenteredHorizontally={true}
          hasGoldBackground
          href='https://business.rolzo.com/auth/register'
          text='Start Now'
        />
      </div>
    </>
  )
}

export default RolzoServices
